@if (showQrButton()) {
  <ion-button
    class="btn-group-start"
    fill="outline"
    [color]="buttonColor()"
    (click)="showDigitalControlDocQr()"
    libClickStopPropagation
  >
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/qr_code_24dp.svg"
    ></ion-icon>
    QR DeCA
  </ion-button>
} @else {
  <ion-button
    class="btn-group-start"
    fill="outline"
    [color]="buttonColor()"
    [disabled]="isOffline()"
    (click)="openLoadingOrder(freight())"
    libClickStopPropagation
  >
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/content_paste_24dp.svg"
    ></ion-icon>
    <!-- {{ 'files.ecmr' | translate }} -->
    Orden de carga
  </ion-button>
}

<ion-button
  class="btn-group-end"
  id="btn-view-docs"
  fill="outline"
  [color]="buttonColor()"
  [disabled]="isOffline()"
  (click)="viewDocs()"
  libClickStopPropagation
>
  <ion-icon
    slot="end"
    aria-label="View more options"
    src="../assets/material-symbols/expand_more_24dp.svg"
  ></ion-icon>
</ion-button>
